import(/* webpackMode: "eager", webpackExports: ["default"] */ "/srv/site/components/builder/HeadingBlock/HeadingBlock.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PrivacyPolicy"] */ "/srv/site/node_modules/@wonderful/wwc/dist/src/modules/PrivacyPolicy/PrivacyPolicy.js");
